import _request from '@/utils/request.js'

var _activity = {
  // 封装活动信息列表接口		
  getIdTitleAll (resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/activity/getIdTitleAll"),
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 指定封装活动信息列表接口		
  getIdTitle (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/activity/getIdTitleAll"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 封装活动信息列表接口		
  getGoodsByActId (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/customer/service/getGoodsByActId"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 封装活动信息列表接口
  getIdTitleByOwnerId (isOwner, resolve, reject) {
    _request.api({
      url: _request.getCardsUrl("/api/activity/getIdTitleByOwnerId"),
      params: {
        isOwner: isOwner ? 1 : 2,
        inProgress: 1
      },
      method: 'get',
      success: resolve,
      error: reject
    })
  },
}

export default _activity